module.exports = __webpack_public_path__ + "static/vik-de677cfaad3b94d908b9f348580aa269.jpg";